<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <router-link
        :to="{
        name: data.item.idEtapa == 79 ?'resumenClinicoSeguimientoVisible': data.item.idEtapa == 80 ?'MetodosDePagoPTIVisible': data.item.idEtapa == 81 ?'DistribucionCobroPTIVisible': '',
        params:
        data.item.idEtapa == 79 ?
        {
         idPti:        data.item.idPti,
         idSolicitud:  data.item.idSolicitud,
         opcion:       data.item.opcionAceptada}:

        data.item.idEtapa === 80?
        {
        idPti:            data.item.idPti,
        idSolicitudEtapa: data.item.idSolicitudEtapa,
        idTicket:      data.item.idSolicitud,
        idEtapa:          data.item.idEtapa,
        opcion:           data.item.opcionAceptada
        }:
         data.item.idEtapa === 81?
        {
        idPti:            data.item.idPti,
        idSolicitudEtapa: data.item.idSolicitudEtapa,
        idTicket:      data.item.idSolicitud,
        idEtapa:          data.item.idEtapa
        }:{},
      }"
    >
      <p
          class="letraColorAzulPrincipal letraEstiloNegrita"
      >
        {{ data["item"].nombrePaciente }}
      </p>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "LinkPacientePtiVisibleComponente",
  props: {
    data: Object,
    resource: Object
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {}
}
</script>

<style scoped>

</style>
